import { render, staticRenderFns } from "./Payouts.vue?vue&type=template&id=e0b4e81e"
import script from "./Payouts.vue?vue&type=script&lang=ts"
export * from "./Payouts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports